<template>
  <q-ajax-bar
    ref="barRef"
    position="top"
    color="primary"
    size="0.1rem"
    skip-hijack
  />
  <router-view />
</template>

<script>
import { ref, onMounted, onUnmounted, watch, computed, provide } from 'vue'
import { useStore } from 'vuex'
import { EventBus, useQuasar } from 'quasar'
import moment from 'moment'

export default {
  name: 'App'
}
</script>

<script setup>
import { setAddressbarColorFromRoute } from 'src/boot/addressbar-color'
import { useRouter } from 'vue-router'
import { isDevelopmentEnv, isHomologEnv } from './utils'

const $store = useStore()
const $router = useRouter()
const $q = useQuasar()

const isAdmin = computed(() => $store.getters['auth/isAdmin'])

let barSubscriber
const barRef = ref(null)
let oldBarValue = false

onMounted(() => {
  barSubscriber = $store.subscribe(({ type, payload }) => {
    if (type !== 'globals/setLoading') return

    if (payload === true) {
      if (oldBarValue !== true) barRef.value.start()
    } else {
      barRef.value.stop()
    }
    oldBarValue = payload
  }, { prepend: true })
})

onUnmounted(() => {
  if (barSubscriber) barSubscriber()
})

const setTheme = (dark) => {
  const isDark = dark === true || dark === 'true'
  localStorage.setItem('darkMode', isDark)
  $q.dark.set(isDark)
}

onMounted(() => {
  const dark = localStorage.getItem('darkMode')
  setTheme(dark)
})

watch(() => $q.dark.isActive, val => {
  setAddressbarColorFromRoute($router.currentRoute.value)
})

// eslint-disable-next-line eqeqeq
const hideEnvironmentBanner = ref(localStorage.getItem('hideEnvironmentBanner') == 'true')
const showEnvironmentBanner = computed({
  get: () => !hideEnvironmentBanner.value && ((isDevelopmentEnv() && !process.env.DEV) || isHomologEnv()),
  set: (val) => {
    hideEnvironmentBanner.value = !val
    localStorage.setItem('hideEnvironmentBanner', !val)
  }
})

provide('showEnvironmentBanner', showEnvironmentBanner)

const showWorkingShiftBanner = computed(() => {
  if ($store.getters['auth/isAdmin']) return false

  const now = moment()

  const baseYear = now.month() === 11 ? now.year() : now.year() - 1

  return now.isBetween(
    moment({ M: 11, d: 17, y: baseYear }),
    moment({ M: 0, d: 2, y: baseYear + 1 })
  )
})

provide('showWorkingShiftBanner', showWorkingShiftBanner)

const showCrmDiscountBanner = computed(() => {
  return !!$store.getters['company/getCompany']?.show_crm_popup && moment().isBefore('2025-01-30 00:00')
})

provide('showCrmDiscountBanner', showCrmDiscountBanner)

const showServiceWorkerUpdateBanner = ref(false)

if (!window.bus) window.bus = new EventBus()
window.bus?.on('sw:updatefound', () => {
  if (showServiceWorkerUpdateBanner.value === false) {
    showServiceWorkerUpdateBanner.value = 'updatefound'
  }
})
window.bus?.on('sw:updated', () => {
  if (isAdmin.value) {
    showServiceWorkerUpdateBanner.value = 'updated'
  } else {
    showServiceWorkerUpdateBanner.value = false

    $q.notify({
      message:
        'Uma nova versão desta aplicação foi detectada. A aplicação será reiniciada para que a atualização tenha efeito.',
      type: 'alert',
      icon: 'update',
      timeout: 5000,
      onDismiss: () => {
        window.location.reload()
      }
    })
  }
})

provide('showServiceWorkerUpdateBanner', showServiceWorkerUpdateBanner)
</script>
